import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';
import {OktaService} from './okta.service';
import {environment} from '../../../environments/environment';
import {IconElement, ImageElement} from './catalog.service';

export interface ServiceElement {
    'serviceID': number,
    'name': string,
    'item': number,
    'typeID': number,
    'productLineID': number,
    'statusID': number,
    'published': boolean,
    'revisionDate': string,
    'tagline': string,
    'problem': string,
    'approach': string,
    'features': string,
    'images': ImageElement[],
    'icons': IconElement,
    'techDescription': string,
    'communityURL': string,
    'previousNames': string[],
    'shortDescription': string,
    'subtitle': string,
    'solutionArea': number,
    'solutionCapability': string
}

@Injectable()
export class ServiceService {
    serviceList: BehaviorSubject<ServiceElement[] | null> = new BehaviorSubject<ServiceElement[] | null>(null);
    loadFailed = false;

    constructor(private http: HttpClient, private oktaService: OktaService) {}

    get servicesUpdated(): Observable<ServiceElement[] | null> {
        return this.serviceList.asObservable();
    }

    refresh() {
        this.loadFailed = false;

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        this.http.get<any>(environment.azure.url + '/admin.services', options).subscribe({
            next: data => {
                this.serviceList.next(data);
                this.loadFailed = false;
            },
            error: msg => {
                this.loadFailed = true;
                this.serviceList.next(null);
                console.log(msg);
            }
        });
    }

    detail(serviceID: number): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };

        return this.http.get<any>(environment.azure.url + '/admin.services/' + serviceID, options);
    }

    add(target: ServiceElement): Observable<any> {
        // Write target to database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };
        return this.http.post<any>(environment.azure.url + '/admin.services.add', {
            name: target.name,
            item: target.item,
            typeID: target.typeID,
            productLineID: target.productLineID,
            statusID: target.statusID,
            published: target.published,
            revisionDate: target.revisionDate,
            tagline: target.tagline,
            problem: target.problem,
            approach: target.approach,
            features: target.features,
            images: JSON.stringify(target.images),
            icons: JSON.stringify(target.icons),
            techDescription: target.techDescription,
            communityURL: target.communityURL,
            previousNames: JSON.stringify(target.previousNames),
            shortDescription: target.shortDescription,
            subtitle: target.subtitle,
            solutionArea: target.solutionArea,
            solutionCapability: target.solutionCapability
        }, options)
    }

    update(target: ServiceElement): Observable<any> {
        // Update target in database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = { headers: headers };
        return this.http.post<any>(environment.azure.url + '/admin.services.update', {
            serviceID: target.serviceID,
            name: target.name,
            item: target.item,
            typeID: target.typeID,
            productLineID: target.productLineID,
            statusID: target.statusID,
            published: target.published,
            revisionDate: target.revisionDate,
            tagline: target.tagline,
            problem: target.problem,
            approach: target.approach,
            features: target.features,
            images: JSON.stringify(target.images),
            icons: JSON.stringify(target.icons),
            techDescription: target.techDescription,
            communityURL: target.communityURL,
            previousNames: JSON.stringify(target.previousNames),
            shortDescription: target.shortDescription,
            subtitle: target.subtitle,
            solutionArea: target.solutionArea,
            solutionCapability: target.solutionCapability
        }, options)
    }
}
